import { Button, Card, Checkbox, Empty, Modal } from "antd";
import { useCallback, useEffect, useState } from "react";
import Loader from "../../../components/loader";
import { NumericFormat } from "react-number-format";
import AccountService from "../../../services/accounts.service";
import { useNavigate } from "react-router";
import { accNoFormat, amountFormat } from "../../../services/common.service";
import ModifyAccountNickName from "./setNickname";
import { useDispatch, useSelector } from "react-redux";
import { setLoanAccountList } from "../../../store/actions/app.action";
import { MdOutlineEdit } from "react-icons/md";
import checkedIcon from "../../../assests/images/checked.svg";
import unCheckedIcon from "../../../assests/icons/uncheck.png";
import { useTranslation } from "react-i18next";
import { modeSelector } from "../../../store/selectors/app.selector";
import LoanGridView from "./loan/loanGrid";
import LoanListItem from "./loan/loanListView";

export default function LoanAccountsList() {
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    fetchAccounts("LA");
  }, []);

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  const fetchAccounts = useCallback(async (type) => {
    try {
      setDataSource([]);
      const response = await AccountService.getLoanAccountSummary(type);
      if (response.status === 200) {
        setDataSource(response.data);
        setNoRecords(response.data.length > 0 ? false : true);
      }
    } catch (error) {}
  }, []);

  const handleChange = useCallback(
    (value, option) => {
      setDataSource((prevDataSource) =>
        prevDataSource.map((account) =>
          account.accountNo === option.accountNo
            ? { ...account, checked: value }
            : { ...account, checked: false }
        )
      );
    },
    []
  );
  
  return (
    <>
      {/* <div className="d-flex align-items-center justify-content-end mb-1">
        <Button
          onClick={() => navigate("/accounts/loan/apply")}
          type="primary"
          style={{ marginLeft: 20, verticalAlign: "top" }}
          className="btn-primary"
        >
          Apply New Loan
        </Button>
      </div> */}

      {showGridAccount === "GRID" && (
        <LoanGridView
          dataSource={dataSource}
          setVisible={setVisible}
          noRecords={noRecords}
          handleChange={handleChange}
        />
      )}

      {showGridAccount === "LIST" && (
        <LoanListItem
          dataSource={dataSource}
          setVisible={setVisible}
          noRecords={noRecords}
          handleChange={handleChange}
          setSelectedDetails={setSelectedDetails}
        />
      )}

      <Modal
        title={t("pages.my_accounts.casa.nickname", {
          defaultValue: "Nickname",
        })}
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        width={480}
        mask={true}
      >
        <ModifyAccountNickName
          key={new Date().getTime()}
          setVisible={setVisible}
          selectedDetails={selectedDetails}
          setRefresh={() => {
            dispatch(setLoanAccountList([]));
            setVisible(false);
            fetchAccounts("LA");
          }}
        />
      </Modal>
    </>
  );
}
